<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'

   export default {
      page: {
         title: "Add Doctor",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         const previous_date = moment().subtract(1, 'days').format("YYYY-MM-DD");
         return {
            title: "Add Doctor",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },
               {
                  text: "Add Doctor",
                  active: true,
               },        
            ],

            
            languages: [],
            qualifications: [],
            doctors: [],

            all_specializations: [],
            all_languages: [],
            clinic_del_session_ids: [],

            sub_specializations: [],
            sub_specialization: [],
             specializations: "",


            name: "",
            mobile: "",
            email: "",
            dob: "",
            gender: "",
            prefix: 1,
            current_hospital: "",
            password: "123456",
            password_confirmation: "123456",
            start_date: "",
            address: "",
            reg_number: "",
            reg_council: "",
            reg_date: "",
            account_number: "",
            account_holder_name: "",
            ifsc_code: "",
            upi_id: "",
            image: "",
            id_proof: "",
            doctor_found: "",
            pin_no: "",
            age_type: "1",
            age: "",

            qualification: '',
            specialization: '',
           
            language: '',
            doctor: '',
            exist_doctor_id: '',
            exist_doctor: '',
            clinic: {
               duration: '',
               fees:'',
               commission: '',
            },
            errors: {},          

           

            clinic_consultation: [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },

            ],
            clinic_consultation_checked: false,
            start: '',
            end: '',
            day: null,
            type: '',
            set_time:'',
            hour:'',
            minutes:'',
            time_name: '',
            duration_id: '',
            consultation_type: '',
            clinic_name: '',
            token_type: '',
            reserved: '',
            matchingDoctor: {},
            duration: '',
            consultation_fee: '',
            clinic_durations: [],
            sessions: {},
            clinic_fees:'',
            countries: [],
            country_code : 1,
            genders: {},
            error_doctor: '',


            durations: [],
            clinic_schedules: [],

            certificates_inputs: [
                  {value: null, preview_image: null, image: null}
              ],
            certificates_images: [],

            today: current_date,
            yesterday: previous_date,

            consultation: {
               address: '',
               clinic_id: '',
               commision: '',
               consultation_fee: '',
               consultation_type: '',
               duration_id: '',
               latitude: '',
               longitude: '',
               location: '',
               place: '',
            },


         };
      },
      mounted() {
         // console.log('clinic_schedules:', this.clinic_schedules);
         // this.clearSession();
      },
      watch: {
         start() {
         this.start = this.start.split(":").slice(0, 2).join(":");
         },
         end() {
         this.end = this.end.split(":").slice(0, 2).join(":");
         },
         duration() {
         this.duration = this.duration.split(":").slice(0, 2).join(":");
         },
      },

      created() {
         this.fetchSpecializations(1);
         this.fetchLanguages(1);
         this.fetchCountryCodes();
         // this.fetchDoctors();
         // this.clearForm();
      },

      methods: {
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 
         handleFormSubmit() {
            this.showModal("pin-modal");
         },
         hideModal(modal) {
            this.$refs[modal].hide();
         },
         checkPin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/check_pin_no";

            let formData = new FormData();
            formData.append("pin_no", this.pin_no); 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     // this.$swal("", response.data.message, "success");
                     this.hideModal('pin-modal');
                     this.addClinicSchedule();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

         fetchSpecializations(type) {
            let url = "api/admin/get-specializations?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.all_specializations = responseData.specializations;
               })
               .catch((err) => console.log(err));
         },

         fetchSubSpecializations(specialization_id) {
            let url = `api/admin/get-subspecializations?specialization_id=${specialization_id}`;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  this.sub_specializations = res.data.data.sub_specializations || [];
                  this.sub_specialization = []; // Clear previous sub-specialization selection
               })
               .catch((err) => console.log(err));
         },


         fetchLanguages(type) {
            let url = "api/admin/get-languages?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.all_languages = responseData.languages;
               })
               .catch((err) => console.log(err));
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },


         fetchDoctors() {  
            let url = "api/admin/consultations/getdoctors?keyword=" + '';         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.doctors = responseData.doctors;
               })
               .catch((err) => console.log(err));
         },


         addDoctor(){

            this.getToken();

            const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "clinic/doctor/add";

            let formData = new FormData();
            formData.append("name", this.name);
            formData.append("country_code", this.country_code);
            formData.append("mobile", this.mobile);
            formData.append("email", this.email);
            formData.append("age_type", this.age_type); 
            formData.append("age", this.age); 
            formData.append("dob", this.dob);
            formData.append("gender", this.gender);
            formData.append("prefix", this.prefix); 
            formData.append("qualification", this.qualification);
            formData.append("current_hospital", this.current_hospital);
            formData.append("password", this.password);
            formData.append("password_confirmation", this.password_confirmation);
            formData.append("start_date", this.start_date);
            formData.append("address", this.address);
            // formData.append("specializations", this.specializations);
            // formData.append("languages", this.languages);
            formData.append("reg_number", this.reg_number);
            formData.append("reg_council", this.reg_council);
            formData.append("reg_date", this.reg_date);
            formData.append("image", this.image);
            formData.append("id_proof", this.proof_image);
            formData.append("specializations", this.specializations); 

            if(this.account_number){
               formData.append("account_number", this.account_number); 
            } else{
               formData.append("account_number", ""); 
            }
            if(this.account_holder_name){
               formData.append("account_holder_name", this.account_holder_name); 
            }else{
               formData.append("account_holder_name", ""); 
            }
            if(this.ifsc_code){
               formData.append("ifsc_code", this.ifsc_code); 
            }else{
               formData.append("ifsc_code", ""); 
            }
            if(this.ifsc_code){
               formData.append("upi_id", this.upi_id); 
            }else{
               formData.append("upi_id", ""); 
            }


            var languages = [];
            for(var j=0; j< this.languages.length; j++) {
               languages.push(this.languages[j].lan_id);
            } 
           
           
            let sub_specializations = this.sub_specialization.map(sub => sub.id);

            formData.append('sub_specializations', JSON.stringify(sub_specializations));
            formData.append('languages', JSON.stringify(languages));

            for(var k = 0; k < this.certificates_images.length; k++) {
               let file = this.certificates_images[k];
               formData.append('certificates[' + k + ']', file);
            }

            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                        this.clearSession();

                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.$router.push({ name: 'doctors'});

                })
                .catch((error) => {

            if (error.response) {
                if (error.response.data.message) {

                    if (typeof error.response.data.message === 'object') {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                                 this.$nextTick(() => {
                                    const firstErrorField = document.querySelector('.is-invalid');
                                    if (firstErrorField) {
                                       firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                       firstErrorField.focus();
                                    }
                                 });
                              }
                        console.log(error.response.status);
                    } else {
                            this.$swal("", error.response.data.message, "error");
                    }
                }
                else {
                    this.$swal("", "Something went wrong", "error");
                    console.log(error.response.status);
                }
            } else {
                this.$swal("", "Something went wrong", "error");
                console.log(error.response.status);
            }

            })
            .finally(() => (this.loading = false));





         },


         fetchShedules(page_url = null){

         this.getToken();
         let url = "clinic/doctor/doctorSchedule?id=" + this.matchingDoctor.id;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               if(responseData){
                  this.clinic_schedules = responseData.schedules;

                  //console.log(this.clinic_schedules);

                        if(this.clinic_schedules) {
                           this.clinic_consultation_checked = true;
                           this.clinic_durations = this.durations;

                           if(this.clinic_schedules.length) {
                              this.setConsultations();
                              this.clinic_durations = this.clinic_schedules.duration;
                              //console.log(this.clinic_durations);
                              this.clinic_fees = this.clinic_schedules[0].consultation_fee;

                           }
                        } else {
                           this.clinic_schedules = this.consultation;
                           this.clinic_durations = this.active_durations;
                        }  
                        
                  }
               
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                     console.log(error.response);

                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
                  console.log(error);

               }
         })
         .finally(() => (this.loading = false));


         },

         addClinicSchedule() {
            
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/doctor/addDoctorScheduleNew";  
       
            let formData = new FormData();

            formData.append("doctor_id", this.matchingDoctor.id); 
            // formData.append("consultation_duration", this.clinic.duration_id); 
            // formData.append("consultation_fee", this.clinic.consultation_fee); 

            // formData.append("clinic_id", this.clinic.clinic_id); 

            formData.append('schedules', JSON.stringify(this.clinic_schedules));
            formData.append('consultation_fee', this.clinic_fees);
            formData.append('del_session_ids', JSON.stringify(this.clinic_del_session_ids));
            
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  //this.clearForm();
                  this.$router.push({ name: 'doctors'});
               })
               .catch((error) => {
                  console.log(error.response);
                  if (error.response) {
                     if (error.response.data.message) {
                        if(error.response.status == 422) {
                           this.errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },         


         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         sessionCheck(day) {
            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
         
            let formData = new FormData();
            formData.append("start_time", this.start); 
            formData.append("end_time", this.end); 
            formData.append("duration", this.duration); 
            formData.append("reserved", this.token_type); 
            formData.append("day_id", day+1); 
            formData.append("doctor_id", this.matchingDoctor.id); 

            let url = "clinic/doctors/schedules/sessionCheck"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     this.addSession(day);
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

         isSessionAddable(day) {
            //alert("day: " + day + ", type: " + type);
            this.day = day;

            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var count = 0;
            count = this.clinic_consultation[day].day.length;

            let formData = new FormData();
            formData.append("doctor_id", this.matchingDoctor.id); 
            formData.append("day", day + 1);             
            formData.append("count", count);                         

            let url = "clinic/doctors/schedules/isSLotAddable2"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {
                     this.showModal('session-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           //this.errors = error.response.data.message;
                           //console.log(this.errors);
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

         removeSession(obj, index) {

            var session = obj[index];

            this.getToken();
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };



            let formData = new FormData();
            formData.append("doctor_id", this.matchingDoctor.id); 
            formData.append("day_id", session.day); 
            formData.append("start_time", session.start); 
            formData.append("end_time", session.end); 

            let url = "clinic/doctors/schedules/isDeletable"; 
            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    //console.log(response);
                    if (response.data.status) {
                     var start = moment.utc('2002-02-02 ' + session.start).format('HH:mm:ss');
                     var end = moment.utc('2002-02-02 ' + session.end).format('HH:mm:ss');

                        if(session.session_id) {
                           this.clinic_del_session_ids.push(session.session_id);
                           //console.log(this.clinic_del_session_ids); 
                        }

                        this.clinic_schedules.forEach(clinic => {                  
                           if(session.day == clinic.day && 
                              start == clinic.start && 
                              end == clinic.end) {
                              this.clinic_schedules.splice(this.clinic_schedules.indexOf(clinic), 1);
                           }
                        });

                        obj.splice(index, 1);

                    } else {
                        this.$swal("", response.data.message, "error");
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response);
                        if (error.response.status == 400) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            if (error.response.data.message) {
                                //this.errors = error.response.data.message;
                                //console.log(this.errors);
                                this.$swal("", "Something went wrong", "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         setConsultations() {
               var sessions;
               var consultation = [
                  { day: [] },
                  { day: [] },
                  { day: [] },
                  { day: [] },
                  { day: [] },
                  { day: [] },
                  { day: [] },
               ];
               var schedules = [];

               sessions = this.clinic_schedules;
               //console.log('sessions:', sessions);

               sessions.forEach(obj => {
                  var session = {};
                  session.start = moment(obj.start_time, 'HH:mm:ss').format('h:mm A');
                  session.end = moment(obj.end_time, 'HH:mm:ss').format('h:mm A');
                  session.session_id = obj.doctor_schedule_session_id;
                  session.day = obj.day_id;
                  session.duration = obj.duration;
                  session.token_type = obj.token_type;
                  session.doctor_id = obj.doctor_id;
                  session.consultation_fee = obj.consultation_fee;

                  if(obj.duration){
                  var set_time = obj.duration;
                  var hour = set_time.split(':')[0];
                  var minutes = set_time.split(':')[1];
                  

                  if (hour != '00') {
                     session.time_name = hour + ' Hr ' + minutes + ' min ';
                  } else {
                     session.time_name = minutes + ' min ';
                  }
                  }
                  //console.log(consultation)

                  //console.log(consultation[index])

                  var index = parseInt(obj.day_id) - 1;
                  consultation[index].day.push(session);

                  var schedule = {};
                  schedule.day = obj.day_id;
                  schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('HH:mm:ss');
                  schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('HH:mm:ss');
                  schedule.session_id = obj.doctor_schedule_session_id;
                  schedule.duration = obj.duration;
                  schedule.token_type = obj.token_type;
                  schedule.doctor_id = obj.doctor_id;
                  schedule.consultation_fee = obj.consultation_fee;
                  schedules.push(schedule);
               });

               this.clinic_consultation = consultation;
               this.clinic_schedules = schedules;
               //console.log('sessionsin :', this.clinic_consultation);

         },

       

         addSubSpecialization(event) {
            let sub_spec_id = event.target.value; 
            let title = event.target.options[event.target.selectedIndex].text; // Get selected text

            if (!sub_spec_id) return; 

            let exists = this.sub_specialization.some(sub => sub.id == sub_spec_id);

            if (!exists) {
               this.sub_specialization.push({ id: sub_spec_id, title: title });
            }

            event.target.value = ""; 
         },


          removeSubSpecialization(index) {
              this.sub_specialization.splice(index, 1);
          }, 
          

          addLanguage() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let lan_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.languages.some(function(language) {
               return index === language.id;
            });

            if(!exists) {
               this.languages.push({ id: index , title: text ,lan_id: lan_id});
            }
            this.language = '';
          },

          removeLanguage(index) {
               this.languages.splice(index, 1);
          }, 

          addQualification() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;

            var exists = this.qualifications.some(function(qualification) {
               return index === qualification.id;
            });

            if(!exists) {
               this.qualifications.push({ id: index , title: text });
              }
            this.qualification = '';
          },

          removeQualification(index) {
              this.qualifications.splice(index, 1);
          },   

          certificates_add() {
              this.certificates_inputs.push({ value: null });
          },

          certificates_remove(index) {
              this.certificates_inputs.splice(index, 1);
              this.certificates_images.splice(index, 1);
          }, 

          setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         setProof(e) {
            this.proof_image = e.target.files[0];
            this.proof_preview_image = URL.createObjectURL(e.target.files[0]);
         },


          certificates_setFile(e, index) {
               this.certificates_images.push(e.target.files[0]);
               this.certificates_inputs[index].image = e.target.files[0];
            this.certificates_inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
         },
         seachDoctor() {
            this.doctor = true;
         },
         addSession(day) {
            console.log(this.clinic_consultation);
            console.log(this.start);
            console.log(this.end);
            console.log(this.clinic_consultation);
            console.log(this.clinic_consultation);
         this.day = day;
         var datetime1 = '2002-02-02 ' + this.start;
         var start = moment.utc(datetime1).format('hh:mm A');
         var datetime2 = '2002-02-02 ' + this.end;
         var end = moment.utc(datetime2).format('hh:mm A');

         if (this.start > this.end) {
            this.$swal("", "Invalid time slot", "error");
            return;
         }

         // Validate if slot time already present in any consultation type
         var invalid = false;
         Object.entries(this.clinic_consultation).forEach(([key, val]) => {
            if (key == this.day) {
               for (var i = 0; i < val['day'].length; i++) {
                  if (this.start >= val['day'][i].start && this.start <= val['day'][i].end ||
                     this.end >= val['day'][i].start && this.end <= val['day'][i].end ||
                     val['day'][i].start >= this.start && val['day'][i].start <= this.end) {
                     invalid = true;
                     break;
                  }
               }
            }
         });

         Object.entries(this.clinic_consultation).forEach(([key,val]) => {
                  if(key == this.day) {
                     if(!invalid) {
                        val['day'].push({start: this.start + ':00', end: this.end + ':00', day: this.day + 1,time_name: this.duration + ':00', token_type: this.token_type, consultation_fee: this.clinic.fees});
                        this.clinic_schedules.push({day: this.day + 1, start: start, end: end, duration: this.duration, token_type: this.token_type, consultation_fee: this.consultation_fee});
                     } else {
                        this.$swal("", "Time already included in clinic consultation", "error");
                     }
                  }
               });
            
            this.clearSession();
            this.$refs['session-modal'].hide();
      },


         clearSession() {
            this.start = '';
            this.end = '';
            this.day = null;
            this.token_type = '';
            this.reserved = 2;
            this.pin_no = '';

         },
         clearForm(){
            this.doctor_found = '';
            this.matchingDoctor = {};
            this.consultation_fee = '';
            this.clinic_schedules = [];
            this.exist_doctor = false;
            // this.clinic_consultation = [];
            this.clinic_consultation= [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },

            ];
         },
         search() {

            // this.matchingDoctor = this.doctors.find(doctor => doctor.id == this.exist_doctor_id);
            // console.log('id', this.matchingDoctor);

            // if(this.matchingDoctor){
            //    this.exist_doctor = true;
            //    this.fetchShedules();
            // }else{
               // this.exist_doctor = false;
               // this.error_doctor = 'The Doctor Is Not In The Clinic';
               // console.log(this.error_doctor);

               

            // }

            let url = "clinic/doctor/getExistingDoctor?doctor_code=" + this.exist_doctor_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     // console.log(responseData);
                     if(responseData.doctor){
                        this.matchingDoctor = responseData.doctor;
                          if(this.matchingDoctor){
                              this.exist_doctor = true;
                              this.clinic_consultation_checked = true;
                              this.fetchShedules();
                           }else{
                              this.exist_doctor = false;
                              this.doctor_found = 'The Doctor Not Found';
                              this.clinic_consultation_checked = false;
                              // console.log(this.error_doctor);
                           }
                     }
                     this.doctor_found = res.data.message;
                  })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));

         },

         //sets the position of marker when dragged
         homeHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         homePanToMarker() {
            this.$refs.homeMapRef.panTo(this.clinic_marker.position);
            this.$refs.homeMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         homeHandleMapClick(e) {
            this.home_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         homeSetPlace(place) {
            this.home_current_place = place;
            if(this.home_current_place) {
               const marker = {
                  lat: this.home_current_place.geometry.location.lat(),
                  lng: this.home_current_place.geometry.location.lng(),
               };
               this.home_center = marker;
               this.home_marker.position = marker;
               this.home_location = place.formatted_address;
            }
         },

         handleImageUpload(type){

            if(type === 1){
               this.image = this.$refs.fileInput.files[0];
            }
            if(type === 2){
               this.id_proof = this.$refs.fileInput.files[0];
            }

         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <div class="row">
                     <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab active>
            <template v-slot:title>
         
             <span class="">New Doctor</span>
            </template>
            <!-- <b-card header-class="bg-transparent border-light" class="border border-light" v-if="add"> -->
                     <form class="form-horizontal" role="form"  @submit.prevent="addDoctor()">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Personal Details</h4>
                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Name <span class="text-danger">*</span></label>
                                 <b-input-group>
                                    <b-input-group-prepend>
                                 <select class="form-control" v-model="prefix">
                                    <option value="1">Dr</option>
                                    <option value="2">Mr</option>
                                    <option value="3">Ms</option>
                                    <option value="4">Others</option>
                                 </select>
                                    </b-input-group-prepend>
                                    <input type="text"  class="form-control" v-model="name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>

                                    <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>  
                                 </b-input-group>
                                 </div>                  
                          

                              <div class="form-group col-md-4">
                                 <label>Mobile Number <span class="text-danger">*</span></label>
                                 <b-input-group>
                                     <b-input-group-prepend>
                                          <select class="form-control"  v-model="country_code">
                                             <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                          </select>
                                     </b-input-group-prepend>
                                     <b-form-input v-model="mobile" maxlength="15" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                     <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div> 
                                 </b-input-group>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Email ID </label>
                                 <input type="email" class="form-control" v-model="email"/>
                              </div>

                               <b-form-group class="col-lg-4 mb-3" v-if="age_type == 1">
                                 <label>
                                    Age <span class="text-danger">*</span>
                                    <span class="ml-2">
                                       <a href="#" @click.prevent="age_type = 2">Enter DOB Instead</a>
                                    </span>
                                 </label>

                                 <b-form-input
                                 type="number"
                                 v-model="age"
                                 min="1"
                                 class="form-control"
                                 :class="{ 'is-invalid': Boolean(errors.age) }"
                                 ></b-form-input>

                           <div v-for="(val, index) in errors.age" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-form-group>
                             
                              <div class="form-group col-md-4" v-if="age_type == 2">
                                 <label>Date of Birth <span class="text-danger">*</span><span class="ml-2">
                                    <a href="#" @click.prevent="age_type = 1">Enter Age Instead</a>
                                 </span></label>
                                 <input type="date" v-model="dob" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.dob) }" :max="today"/>

                                 <div v-for="(val, index) in errors.dob" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Gender <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="gender" v-bind:class="{ 'is-invalid': Boolean(errors.gender) }">
                                    <option value="">Select</option>
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                    <option value="3">Others</option>  
                                 </select>
                                 <div v-for="(val, index) in errors.gender" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Qualification <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="qualification"  v-bind:class="{ 'is-invalid': Boolean(errors.qualification) }"/>
                                 <div v-for="(val, index) in errors.qualification" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Currently Practicing Hospital</label>
                                 <input type="text" class="form-control" v-model="current_hospital"/>
                              </div>
                              
                              <div class="form-group col-md-4">
                                 <label>Password <span class="text-danger">*</span></label>
                                 <input type="password" class="form-control" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>

                                 <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Confirm Password <span class="text-danger">*</span></label>
                                 <input type="password"  class="form-control" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>

                                 <div v-for="(val, index) in errors.start_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Start Date <span class="text-danger">*</span></label>
                                 <input type="date"  class="form-control" v-model="start_date"  v-bind:class="{ 'is-invalid': Boolean(errors.start_date) }" :max="today" />

                                 <div v-for="(val, index) in errors.start_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Address <span class="text-danger">*</span></label>
                                 <textarea rows="2"  class="form-control" v-model="address" ></textarea>

                                 <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>                           
                              <!-- <div class="form-group col-md-4">
                                 <label class="control-label">Commision<span class="text-danger">*</span></label>
                                 <b-form-input type="number" min="0"  ></b-form-input>
                                 
                                 <div class="invalid-feedback">
                                    <p class="mb-0"> </p>
                                 </div>
                              </div> -->
                           </div>
                        </b-card>

                        <div class="row">
                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Specializations</h4>

                                 <div class="row">
                                    <div class="form-group col-12">                                   
                                       <select class="form-control" v-if="all_specializations.length > 0" @change="fetchSubSpecializations($event.target.value)" v-model="specializations" v-bind:class="{ 'is-invalid': Boolean(errors.specializations) }">
                                          <option value="">Select</option>
                                          <option :value="specialization.id" v-for="specialization in all_specializations" :key="specialization.id">{{specialization.specialization}}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.specializations" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>

                                 </div>
                              </b-card>
                           </div>

                            <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Sub Specialization</h4>

                                 <div class="row">
                                    <div class="form-group col-12">                                   
                                       <select class="form-control"  @change="addSubSpecialization($event)" v-bind:class="{ 'is-invalid': Boolean(errors.sub_specializations) }">
                                             <option value="">Select</option>
                                             <option v-for="sub in sub_specializations" :key="sub.id" :value="sub.id">
                                                {{ sub.sub_specialization }}
                                             </option>
                                       </select>

                                       <div v-for="(val, index) in errors.sub_specializations" :key="index" class="invalid-feedback">
                                             <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>
                                 </div>

                             <div class="col-12">
                                 <div class="input-tag" v-for="(sub, index) in sub_specialization" :key="index">
                                    <p>
                                       {{ sub.title }}
                                       <span @click="removeSubSpecialization(index)" class="text-danger">
                                          <i class="fas fa-times-circle"></i>
                                       </span>
                                    </p>
                                 </div>
                              </div>

                            </b-card>    
                           </div>

                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Languages</h4>

                                 <div class="row">
                                    <div class="form-group col-12">
                                       <select class="form-control" @change="addLanguage()" v-model="this.language">
                                          <option value="">Select</option>
                                          <option :value="language.id" v-for="language in all_languages" :key="language.id">{{language.language}}</option>
                                       </select>
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(language, index) in languages" :key="index">
                                             <p>{{ language.title }}<span @click="removeLanguage(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                                 </div>

                              </b-card>
                           </div>
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Registration Details</h4>

                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Reg. No. <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="reg_number" v-bind:class="{ 'is-invalid': Boolean(errors.reg_number) }"/>
                                 <div v-for="(val, index) in errors.reg_number" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Council <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="reg_council" v-bind:class="{ 'is-invalid': Boolean(errors.reg_council) }"/>
                                 <div v-for="(val, index) in errors.reg_council" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Date <span class="text-danger">*</span></label>
                                 <input type="date" class="form-control" v-model="reg_date" v-bind:class="{ 'is-invalid': Boolean(errors.reg_date) }"/>
                                 <div v-for="(val, index) in errors.reg_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>      
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Bank Details</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Account No. </label>
                                 <input type="text" class="form-control" v-model="account_number" v-bind:class="{ 'is-invalid': Boolean(errors.account_number) }"/>
                                 <div v-for="(val, index) in errors.account_number" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>Account Holder Name </label>
                                 <input type="text" class="form-control" v-model="account_holder_name" v-bind:class="{ 'is-invalid': Boolean(errors.account_holder_name) }"/>
                                 <div v-for="(val, index) in errors.account_holder_name" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>IFSC Code </label>
                                 <input type="text" class="form-control" v-model="ifsc_code" v-bind:class="{ 'is-invalid': Boolean(errors.ifsc_code) }"/>
                                 <div v-for="(val, index) in errors.ifsc_code" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>UPI ID </label>
                                 <input type="text" class="form-control" v-model="upi_id" v-bind:class="{ 'is-invalid': Boolean(errors.upi_id) }"/>
                                 <div v-for="(val, index) in errors.upi_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>      
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Image</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Profile Image <span class="text-danger">*</span></label>
                                 <input type="file" class="form-control" @change="setFile($event)" accept=".png,.jpg,.jpeg" v-bind:class="{ 'is-invalid': Boolean(errors.image) }">
                                 <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                              
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <input type="file" class="form-control" @change="setProof($event)" accept=".png,.jpg,.jpeg" v-bind:class="{ 'is-invalid': Boolean(errors.id_proof) }">
                                 <div v-for="(val, index) in errors.id_proof" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                              
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Certificates</h4>

                           <b-row v-for="(input, index) in certificates_inputs" :key="index">    
                              <b-col md="6" class="form-group">
                                 <div class="w-90">
                                    <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"  v-model="input.value" @change="certificates_setFile($event, index)" v-bind:class="{ 'is-invalid': Boolean(errors.certificates) }"></b-form-file>
                                    <div v-for="(val, index) in errors.certificates" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </div>

                                 <span class="ml-1 mt-2">
                                    <i class="fas fa-minus-circle text-danger" @click="certificates_remove(index)" v-show="index || ( !index && certificates_inputs.length > 1)"></i>
                                    <i class="fas fa-plus-circle text-success" @click="certificates_add()" v-show="index == certificates_inputs.length-1"></i>
                                 </span>
                              </b-col>
                              <!-- <b-col md="6">
                                 <img class="image-preview" v-bind:src="input.preview_image">
                              </b-col> -->
                           </b-row>
                        </b-card>


                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form> 
                   <!-- </b-card> -->
            </b-tab>

            <b-tab>
            <template v-slot:title>
          
            <span class="">Existing Doctor</span>
            </template>
            <!-- <form class="form-horizontal" role="form"  @submit.prevent="search()"> -->
               <b-card header-class="bg-transparent border-light" class="border border-light">
               <div class="row">
                  <div class="col-lg-6">

                     <label>Doctor ID <span class="text-danger">*</span></label>
                  
                     <b-input-group  class="mt-3">
                     <b-form-input v-model="exist_doctor_id" @keyup="clearForm" v-bind:class="{ 'is-invalid': Boolean(errors.doctor_code) }"></b-form-input>
                     <b-input-group-append>
                        <b-button variant="primary" @click="search()">Search</b-button>   
                     </b-input-group-append>
                  </b-input-group>
                  <div class="invalid-feedback" >
                     <p class="mb-0">Hello</p>
                  </div>
                  <div v-if="doctor_found">{{ this.doctor_found }}</div>
                 
                  </div>
               </div>
            </b-card>
            <div v-if="exist_doctor">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Doctor Details</h4>
                           <div class="row">
                           <div class="col-lg-6">  
                           <table class="table table-nowrap mb-0">
                                    <tbody>
                                       <tr>
                                          <th width="45%">ID</th>
                                          <th width="5%">:</th>
                                          <td width="50%">{{matchingDoctor.code}}</td>
                                       </tr>
                                       <tr>
                                          <th width="45%">Name</th>
                                          <th width="5%">:</th>
                                          <td width="50%">Dr. {{matchingDoctor.name}}</td>
                                       </tr> 
                                       <tr>
                                          <th width="45%">Gender</th>
                                          <th width="5%">:</th>
                                          <td width="50%">
                                             <span v-if="matchingDoctor.gender == 1">Male</span>
                                             <span v-if="matchingDoctor.gender == 2">Female</span>
                                             <span v-if="matchingDoctor.gender == 3">Others</span>
                                          </td>
                                       </tr> 
                                    </tbody>
                           </table> 
                           </div>
                           <div class="col-lg-6">  
                           <table class="table table-nowrap mb-0">
                                    <tbody>
                                       <tr>
                                          <th width="45%">D.O.B</th>
                                          <th width="5%">:</th>
                                          <td width="50%">{{matchingDoctor.dob | formatDate}}</td>
                                       </tr>
                                       <tr>
                                          <th width="45%">Specializations</th>
                                          <th width="5%">:</th>
                                          <td width="50%">
                                             <span v-for="(specialization, index) in matchingDoctor.specialization" :key="index">
                                                   {{ specialization.specialization }}
                                                   <span v-if="index < matchingDoctor.specialization.length - 1">, </span>
                                             </span>
                                          </td>
                                       </tr> 
                                       <tr>
                                          <th width="45%">Languages</th>
                                          <th width="5%">:</th>
                                          <td width="50%">
                                             <span v-for="(language, index) in matchingDoctor.language" :key="index">
                                                   {{ language.language }}
                                                   <span v-if="index < matchingDoctor.language.length - 1">, </span>
                                             </span>
                                          </td>
                                       </tr> 
                                    </tbody>
                           </table> 
                           </div>
                        </div>
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light schedules clinic-schedules">     
                  <!-- <form @submit.prevent="addClinicSchedule()">                     -->
                     <form @submit.prevent="handleFormSubmit()">                    
                     <h5 class="card-title mb-4">
                        <!-- Clinic Consultation                            -->
                        <!-- <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="clinic_consultation_checked"/>
                        </div> -->
                     </h5> 
                     <ul class="reservervation-defs">
                        <li><i class="fas fa-square reserved-color"></i> Both</li>
                        <li><i class="fas fa-square not-reserved-color"></i> Token Vending Machine Only</li>
                     </ul>                     
                     <div class="row m-0" style="clear:both;" >
                        <div class="col-md-6 col-lg-7 col-xl-7">
                           <label>Session Timings <span class="text-danger">*</span></label>

                           <div class="table-responsive">
                                    
                              <table class="table table-bordered w-100">

                                 <!---- Monday starts-------->
                                 <tr>                                      
                                    <td scope="row">Mon</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[0].day" :key="index">
                                                <p>{{ session.start}} - {{ session.end }} | {{session.time_name}}<span @click="removeSession(clinic_consultation[0].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">      
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(0, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>              
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=0, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Monday ends -------->

                                 <!---- Tuesday starts-------->
                                 <tr>
                                    <td>Tue</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[1].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}}<span @click="removeSession(clinic_consultation[1].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">   
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(1, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                               
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=1, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Tuesday ends-------->

                                 <!---- Wednesday starts-------->
                                 <tr>
                                    <td>Wed</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[2].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}}<span @click="removeSession(clinic_consultation[2].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(2, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                               
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=2, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Wednesday starts-------->

                                 <!---- Thursday starts-------->
                                 <tr>
                                    <td>Thu</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[3].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}}<span @click="removeSession(clinic_consultation[3].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(3, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                               
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=3, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Thursday starts-------->

                                 <!---- Friday starts-------->
                                 <tr>
                                    <td>Fri</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[4].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}}<span @click="removeSession(clinic_consultation[4].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(4, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                               
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=4, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Friday starts-------->

                                 <!---- Saturday starts-------->
                                 <tr>
                                    <td>Sat</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[5].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}}<span @click="removeSession(clinic_consultation[5].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                   
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(5, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                                
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=5, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Saturday ends-------->

                                 <!---- Sunday starts-------->
                                 <tr>
                                    <td>Sun</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[6].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}}<span @click="removeSession(clinic_consultation[6].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(6, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                                
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=6, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Sunday ends-------->

                              </table>
                           </div>
                        </div>
                        <div class="col-md-6 col-lg-5 col-xl-5 consultation-details">
                           <!-- <div class="form-group">
                              <label>Consultation Duration <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="clinic.duration">
                                 <option value="" v-if="!clinic.duration">Select</option>
                                 <option value="1">5 minutes</option>
                                 <option value="2">10 minutes</option>
                                 <option value="3">15 minutes</option>
                                 <option value="4">30 minutes</option>
                                 <option value="5">1 hour</option>
                              </select>
                           </div>    -->

                           <div class="form-group">
                              <label>Consultation Fee (in Rs.) <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="clinic_fees" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_fee) }"/>
                              <div v-for="(val, index) in errors.consultation_fee" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   

                           <!-- <div class="form-group">
                              <label>Clinic <span class="text-danger">*</span></label>
                              <select class="form-control">
                                    <option value="">Select</option>
                                    <option value="1">Clinic 1</option>
                                    <option value="2">Clinic 2</option>
                                    <option value="3">Clinic 3</option>
                                    <option value="4">Clinic 5</option>
                                    <option value="5">Clinic 5</option>
                              </select>
                           </div> -->

                        </div>


                        <div class="col-12 my-2">
                           <button type="submit" class="btn btn-primary">Submit</button>
                        </div>
                     </div>
                     <!-- <div class="row" v-else>
                        <div class="col-12">
                           <p>Not scheduled</p>
                        </div>
                     </div>    -->
                     
                  </form>         
                  </b-card>
               </div>
          
            </b-tab>
            
            </b-tabs>
               <!---- modal starts ---->
               <!---- modal starts ---->
               <b-modal ref="session-modal" id="session-modal" title="Add Session" hide-footer>
                  <!-- <b-form @submit.prevent="addSession(day)">     -->
                  <b-form @submit.prevent="sessionCheck(day)">    
   

         <!-- <div class="form-group" v-if="type=='clinic'">
            <label>Clinic <span class="text-danger">*</span></label>
            <b-form-select v-model="clinic_id" :options="clinics" class="form-control" @change="setClinicName"></b-form-select>
         </div>                     -->

         <b-col md="12" class="form-group">
            <label class="control-label">Start Time<span class="text-danger">*</span></label>
            <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->  
            <!-- <b-form-input v-model="start" type="time" v-bind:class="{ 'is-invalid': Boolean(errors.start_time) }" readonly></b-form-input> -->
            <b-input-group class="mb-3">
            <b-form-input id="example-input" v-model="start" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.start_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="start" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.start_time" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p></div>
                  </b-input-group>
         </b-col>

         <b-col md="12" class="form-group">
            <label class="control-label">End Time<span class="text-danger">*</span></label>
            <!-- <b-form-timepicker v-model="end" locale="en" size="sm"></b-form-timepicker> -->
            <!-- <b-form-input v-model="end" type="time" v-bind:class="{ 'is-invalid': Boolean(errors.end_time) }" readonly></b-form-input> -->
            <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="end" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.end_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="end" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.end_time" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p></div>
                  </b-input-group>
         </b-col>

         <!-- <b-col md="12" class="form-group">
            <label>Consultation Duration <span class="text-danger">*</span></label>
         
            <b-form-select v-model="duration_id" :options="durations" class="form-control"></b-form-select>
         </b-col> -->


         <!-- <b-col md="12" class="form-group">
            <label>Reserved For <span class="text-danger">*</span></label>
            <select class="form-control" v-model="reserved">
               <option value="1">Token Vending Machine</option>
               <option value="3">Both </option>
            </select>
         </b-col> -->
         <b-row md="12" class="form-group">
         
         <b-col md="6" class="form-group">
            <label>Consultation Duration <span class="text-danger">*</span></label>

            <!-- <b-form-input v-model="duration" type="time" @change="setTime()" readonly v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
            <div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
            <span class="ms-1"> {{time_name}}</span> -->
            <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="duration" @input="setTime()" type="text" placeholder="HH:mm" readonly v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
                     <b-input-group-append>
                        <b-form-timepicker v-model="duration" @input="setTime()" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker>
                     </b-input-group-append>
                     <div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                  </b-input-group>
         </b-col>
         <b-col md="6" class="form-group">

            <label>Reserved For <span class="text-danger">*</span></label>
               <select class="form-control" v-model="token_type" v-bind:class="{ 'is-invalid': Boolean(errors.reserved) }">
                  <option value="">Select</option>
                  <option value="2">Token Vending Machine</option>
                  <!-- <option value="2">Mobile App</option> -->
                  <option value="1">Both </option>
               </select>
               <div v-for="(val, index) in errors.reserved" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p></div>
         </b-col>
         </b-row>
                  
         <b-col md="12">
            <b-button type="submit" class="me-3" variant="primary">OK</b-button>
            <b-button class="" variant="light" @click="$bvModal.hide('session-modal')">Cancel</b-button>
         </b-col>

         </b-form>
         </b-modal>
         <!---- modal ends ----->
            <b-modal ref="pin-modal" id="pin-modal" title="" hide-footer @hidden="clearSession()">
            <b-form @submit.prevent="checkPin()">
               <b-row>  
                  <b-col lg="12" class="form-group">
                     <label class="control-label">Pin Number<span class="text-danger">*</span></label>
                     <b-form-input v-model="pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                     <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                  </b-col>  
                  
                  <b-col lg="12">
                     <b-button type="submit" class="me-3" variant="primary">Submit</b-button>
                     <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
                  </b-col>
               </b-row>
            </b-form>
         </b-modal>

                     </div>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
